module.exports = __webpack_public_path__ + "img/bs-1.5268657d.jpg";